import React from 'react';

import { Flex } from '@chakra-ui/react';

import { CohortDropdownLifecycleFilter } from './CohortDropdownLifecycleFilter';
import { CohortMetaFilterDropdown } from './CohortMetaFiltersLifecycleInsights';
import { EmployeeMetaFilterDropdown } from './EmployeeMetaFilterDropdown';
import { FunctionsMetaFilterDropdown } from './FunctionsMetaFilterDropdown';
import { ObjectiveDropdownLifecycleFilter } from './ObjectiveDropdownLifecycleFilter';

const MetaFiltersLifecycleInsights = ({ selectedIntent }) => {
  // TODO : add intent into  redux slice in V1
  //   const { selectedIntent } = useSelectLifecycleSelectedIntent() ?? {};
  //   const { showCohortDropdown, showObjectiveDropdown } = selectedIntent ?? {};

  let showCohortDropdown = true;
  let showObjectiveDropdown = true;
  let showEmployeeIntent = false;
  let showFunctionIntent = false;
  let showCohortIntent = false;

  const isOnboardIntent = selectedIntent?.category === 'DEVELOP' && selectedIntent?.label === 'Finding ideal mentors';

  const isProgressIntent = selectedIntent?.category === 'PROGRESS';

  if (isOnboardIntent) {
    showCohortDropdown = false;
    showObjectiveDropdown = false;
    showEmployeeIntent = true;
    showFunctionIntent = true;
  }

  if (isProgressIntent) {
    showCohortDropdown = false;
    showObjectiveDropdown = false;
    showEmployeeIntent = false;
    showFunctionIntent = false;
    showCohortIntent = true;
  }

  return (
    <Flex gap="12px">
      {showCohortDropdown && <CohortDropdownLifecycleFilter />}
      {showObjectiveDropdown && <ObjectiveDropdownLifecycleFilter />}
      {showEmployeeIntent && <EmployeeMetaFilterDropdown />}
      {showFunctionIntent && <FunctionsMetaFilterDropdown />}
      {showCohortIntent && <CohortMetaFilterDropdown />}
    </Flex>
  );
};

export { MetaFiltersLifecycleInsights };
